import { Component, Vue } from 'vue-property-decorator';
import { localizedRoute as localizedRouteHelper } from '../../i18n/helpers';

@Component
export default class Localisable extends Vue {
  public get locale(): string {
    return this.$store.state.app.locale;
  }

  public localizedRoute(obj: any): any {
    return localizedRouteHelper(obj, this.locale);
  }
}
